<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - #{$navbar-height} - #{$tags-height});
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-top: calc(#{$navbar-height} + #{$tags-height});
  background:
    radial-gradient(900px 320px at 100% 0%, rgba(64, 128, 255, 0.08), transparent 55%),
    $page-bg;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.28s ease;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateY(8px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
